import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationHelpNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M8.775 5.25h-1.4c-.621 0-1.125.504-1.125 1.125V7H5v-.625A2.375 2.375 0 017.375 4h1.4a2.225 2.225 0 011.379 3.971L8.768 9.065a.375.375 0 00-.143.295V10h-1.25v-.64c0-.498.228-.968.618-1.276L9.38 6.99a.975.975 0 00-.604-1.74zM8.625 12v-1.25h-1.25V12z" />
        <path d="M0 8a8 8 0 1116 0A8 8 0 010 8zm8-6.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5z" />
      </g>
    </svg>
  )
);
SvgNavigationHelpNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationHelpNormalXsmall;
